import { render, staticRenderFns } from "./superhttp.vue?vue&type=template&id=ef998d94&scoped=true&"
import script from "./superhttp.vue?vue&type=script&lang=js&"
export * from "./superhttp.vue?vue&type=script&lang=js&"
import style0 from "./superhttp.vue?vue&type=style&index=0&id=ef998d94&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef998d94",
  null
  
)

export default component.exports